module.exports = __webpack_public_path__ + "img/10_80.ed85d663.png";